import { Button, Text, Box, Input } from "@chakra-ui/react";
import WithAuth from "../components/hoc/with-auth";
import { AuthLayout } from "../components/layouts/index";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx/index";
import DailyPage from "../components/pages/daily-page";

const DailyReport = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Daily Report"
          pageDesc="List of all daily report"
        >
          <DailyPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default DailyReport;
